/** Bảng nâng cấp cửa hàng. */
import { capHienTai, chiPhiNangCap, coTheNangCap } from '../../core/cua-hang.js';
import type { GameController } from '../game-controller.js';
import { dinhDangXu, styleNutChinh, styleNutPhu, stylePanel, useCapNhat } from '../dung-chung.js';

export function PanelNangCap(props: { controller: GameController; baoDaNangCap: () => void }) {
  const { controller } = props;
  useCapNhat(controller);
  const { state, duLieu } = controller;
  const cap = capHienTai(state, duLieu);
  const chiPhi = chiPhiNangCap(state, duLieu);
  const duoc = coTheNangCap(state, duLieu);

  const bamNangCap = (): void => {
    if (controller.nangCapCuaHang()) {
      props.baoDaNangCap();
    } else {
      alert('Chưa đủ xu để nâng cấp.');
    }
  };

  return (
    <div style={stylePanel}>
      <h3 style={{ margin: '0 0 8px' }}>🏪 Nâng cấp cửa hàng</h3>
      <p style={{ margin: '0 0 8px', fontSize: '14px' }}>
        Hiện tại: <strong>{cap.ten}</strong> (cấp {cap.cap})
      </p>
      {chiPhi === null ? (
        <p style={{ fontSize: '13px', opacity: 0.85 }}>Đã đạt cấp cao nhất ở Phố chợ.</p>
      ) : (
        <div>
          <p style={{ margin: '0 0 8px', fontSize: '13px', opacity: 0.9 }}>
            Lên cấp {cap.cap + 1}: {dinhDangXu(chiPhi)} — mở thêm mặt hàng, đông khách hơn, khu vực
            rộng hơn.
          </p>
          <button onClick={bamNangCap} disabled={!duoc} style={duoc ? styleNutChinh : styleNutPhu}>
            Nâng cấp ({dinhDangXu(chiPhi)})
          </button>
          {!duoc && (
            <p style={{ fontSize: '12px', color: '#e08a8a' }}>
              Cần thêm {dinhDangXu(chiPhi - state.xu)} nữa.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
